module.exports = __webpack_public_path__ + "static/media/main.768154f6.png";